import * as React from "react"

/*
 * Created by aditya on 18/6/2018
 */

export interface LazyLoaderProps {
    reachedEndTrigger: () => void,
    children?: any
}

class LazyLoaderComponent extends React.Component<LazyLoaderProps> {
    private lazyLoaderDOM: any;

    constructor(props: LazyLoaderProps) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener("scroll", this.trackScrolling);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.trackScrolling);
    }

    isBottom = () => {
        let element = this.lazyLoaderDOM;
        return element.getBoundingClientRect().bottom >= window.innerHeight;
    }

    trackScrolling = () => {
        if (this.isBottom()) {
            console.log("Reached bottom of lazy loader");
            if (this.props.reachedEndTrigger !== undefined && typeof this.props.reachedEndTrigger === "function") this.props.reachedEndTrigger();
        }
    }

    render() {
        return (
            <div ref={lazyLoaderDOM => this.lazyLoaderDOM = lazyLoaderDOM} className={"lazy-loader-container"} onScroll={this.trackScrolling}>
                {this.props.children}
            </div>
        )
    }
}

export default LazyLoaderComponent;